import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  formControl: {
    width: '100%',
  },
  radioGroup: {
    gap: '0.5rem',
  },
});
